import {
  FETCH_NAGRA_MONITORING_OPERATIONS_REQUEST,
  FETCH_NAGRA_MONITORING_OPERATIONS_SUCCESS,
  FETCH_NAGRA_MONITORING_OPERATIONS_FAILURE,
  CREATE_NAGRA_MONITORING_OPERATION_REQUEST,
  CREATE_NAGRA_MONITORING_OPERATION_SUCCESS,
  CREATE_NAGRA_MONITORING_OPERATION_FAILURE,
  END_NAGRA_MONITORING_OPERATION_REQUEST,
  END_NAGRA_MONITORING_OPERATION_SUCCESS,
  END_NAGRA_MONITORING_OPERATION_FAILURE,
} from '../../../actions/actionTypes';

const initialState = {
  operationsDoc: null,
  loading: false,
  creating: false,
  ending: null,
  error: null,
};

function nagraMonitoring(state = initialState, action) {
  switch (action.type) {
    case FETCH_NAGRA_MONITORING_OPERATIONS_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_NAGRA_MONITORING_OPERATIONS_SUCCESS:
      return { ...state, loading: false, operationsDoc: action.payload.operationsDoc };
    case FETCH_NAGRA_MONITORING_OPERATIONS_FAILURE:
      return { ...state, loading: false, error: action.payload.error };

    case CREATE_NAGRA_MONITORING_OPERATION_REQUEST:
      return { ...state, creating: true, error: null };
    case CREATE_NAGRA_MONITORING_OPERATION_SUCCESS:
      return { ...state, creating: false, operationsDoc: action.payload.operationsDoc };
    case CREATE_NAGRA_MONITORING_OPERATION_FAILURE:
      return { ...state, creating: false, error: action.payload.error };

    case END_NAGRA_MONITORING_OPERATION_REQUEST:
      return { ...state, ending: action.payload.monitoring_uuid, error: null };
    case END_NAGRA_MONITORING_OPERATION_SUCCESS:
      return { ...state, ending: null, operationsDoc: action.payload.operationsDoc };
    case END_NAGRA_MONITORING_OPERATION_FAILURE:
      return { ...state, ending: null, error: action.payload.error };

    default:
      return state;
  }
}

export default nagraMonitoring;
